import { shutdown } from '@intercom/messenger-js-sdk';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type User = {
  email: string;
  name: string;
  companyName: string;
  permissionPolicy?: number;
  id?: number;
  companyTypes?: string[];
  products?: { typeId: string; type: { name: string; description: string } }[];
  express?: boolean;
  clientId?: string;
  autoEnrrolled?: boolean;
  businessId?: string;
  companyId: number;
  dataVersion?: string;
  businessIdentifier?: string;
  roles?: {
    id: number;
    name: string;
    permissions: {
      name: string;
      type: string;
      label: string;
      description: string;
    }[];
  }[];
  intercomHash?: string;
};

export type AuthState = {
  isAuthenticated: boolean;
  user?: User; // This represents the logged-in user's details
};

const initialState: AuthState = {
  isAuthenticated: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authenticate: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.user = action.payload; // Store the user's details
    },
    logout: (state) => {
      shutdown();
      state.isAuthenticated = false;
      state.user = undefined; // Clear the user's details on logout
    },
    updateUserEnrollment: (
      state,
      action: PayloadAction<{
        autoEnrrolled: boolean;
        businessId: string;
        businessIdentifier: string;
      }>,
    ) => {
      if (state.user) {
        state.user.autoEnrrolled = action.payload.autoEnrrolled;
        state.user.businessId = action.payload.businessId;
        state.user.businessIdentifier = action.payload.businessIdentifier;
      }
    },
  },
});

export const { authenticate, logout, updateUserEnrollment } = authSlice.actions;

export default authSlice.reducer;
